import React, { Suspense, lazy, useEffect, useState } from 'react';
import 'jsoneditor-react/es/editor.min.css';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';

const JsonEditor = ({ json, handleChange }) => {
  const mode = 'code';
  const modes = ['tree', 'form', 'view', 'code', 'text'];
  const [currentMode, setCurrentMode] = useState(mode);
  const [jsonValue, setJSONValue] = useState(json);

  const onModeChange = (mode) => {
    setCurrentMode(mode);
  };

  useEffect(() => {
    setCurrentMode(mode);
  }, [mode]);

  useEffect(() => {
    setJSONValue(json);
  }, [json]);

  return (
    <Box>
      <Editor
        value={jsonValue}
        mode={currentMode}
        allowedModes={modes}
        ace={ace}
        theme="ace/theme/github"
        onChange={handleChange}
        onModeChange={onModeChange}
      />
    </Box>
  );
};

JsonEditor.propTypes = {
  json: PropTypes.any.isRequired,
  handleChange: PropTypes.func.isRequired,
};

JsonEditor.defaultProps = {
  handleChange: () => {},
};

export default JsonEditor;
